// src/components/WorkspaceLayout.js
/**
 * [공통 레이아웃] 모든 워크스페이스 페이지의 기본 레이아웃
 * - 사이드바 + 페이지 헤더 + 콘텐츠 영역
 * - 모든 페이지에서 헤더 위치가 일관되게 유지됨
 * 
 * 사용법:
 * <WorkspaceLayout>
 *   <div>페이지 콘텐츠</div>
 * </WorkspaceLayout>
 */

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CommonSidebar from './CommonSidebar';
import { useAppContext } from '../context/AppContext';
import './WorkspaceLayout.scss';
import PageHeader from './PageHeader';

const WorkspaceLayout = ({
  children,
  hideCollapseButton = false,
  defaultCollapsed = true,
  hidePageHeader = false,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(defaultCollapsed);
  const { isLoggedIn, user } = useAppContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoggedIn) {
      return;
    }
    // 비밀번호 변경 필요 시 강제 리다이렉트
    if (user?.password_reset_required) {
      navigate('/change-password');
    }
  }, [isLoggedIn, user, navigate]);

  return (
    <div className="workspace-layout">
      {/* [공통] 사이드바 */}
      <CommonSidebar 
        isCollapsed={isCollapsed} 
        onToggleCollapse={
          hideCollapseButton
            ? undefined
            : () => setIsCollapsed((prev) => !prev)
        }
        hideToggleButton={hideCollapseButton}
      />

      {/* [공통] 메인 콘텐츠 영역 */}
      <div className="workspace-content">
        {/* [공통] 페이지 헤더 (전역 상태 기반) */}
        {!hidePageHeader ? <PageHeader /> : null}
        {/* [페이지별] 실제 콘텐츠 영역 */}
        <div className="workspace-body">
          {children}
        </div>
      </div>
    </div>
  );
};

export default WorkspaceLayout;
